import { Contact_Request } from "../models/Contact";
import { contact } from "../services/Contact";

export const PostContact = async (conatc: Contact_Request) => {
  const data = await contact.postContact(conatc);
};
